// Hideo - script editor: the kinds of block with their name (English source, shown with t()) and icon, one table for
// every menu that lists them: the "/" menu (surface/slash.ts), the block menu's "Turn into" (surface/blocks.ts), the
// styles (styles.ts) and the toolbar's lists (toolbar.ts). Each menu takes the kinds it offers, in its own order.
import { t } from '../../i18n'

export const BLOCK_KINDS = {
  p: ['Text', 'fa-font'], h1: ['Heading 1', 'fa-heading'], h2: ['Heading 2', 'fa-heading'], h3: ['Heading 3', 'fa-heading'], h4: ['Heading 4', 'fa-heading'],
  ul: ['Bulleted list', 'fa-list-ul'], ol: ['Numbered list', 'fa-list-ol'], todo: ['Checklist', 'fa-square-check'], toggle: ['Toggle list', 'fa-caret-right'],
  pre: ['Code', 'fa-code'], blockquote: ['Quote', 'fa-quote-right'], callout: ['Callout', 'fa-lightbulb'], hr: ['Divider', 'fa-minus'],
  link: ['Link to an external site', 'fa-link']
} as const satisfies Record<string, readonly [string, string]>
export type BlockKind = keyof typeof BLOCK_KINDS

/** Name of a kind in the UI language */
export const blockName = (k: BlockKind): string => t(BLOCK_KINDS[k][0])
/** Icon of a kind */
export const blockIcon = (k: BlockKind): string => BLOCK_KINDS[k][1]
